<div
  class="flex justify-center text-center tablet:text-body-xs mobile:text-caption-book text-navigation gap-4 mb-32"
>
  <span class="flex items-center">
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.66671 0H8.66671H10V1.33333L10 7.33333H8.66671V2.21282L0.944152 10L0.00134277 9.0493L7.65328 1.33333H2.66671V0Z"
        fill="#9599AC"
      />
    </svg>
  </span>
  <p
    id="mach-homepage-footer-infomation-p1"
    [innerHTML]="contentInfo.footerExtDesc || ''"
  ></p>
</div>

<div class="tablet:h-auto mobile:h-16">
  <p
    id="mach-homepage-footer-infomation-p2"
    class="tablet:text-body-xs mobile:text-caption-book text-center text-navigation flex-none order-0 mb-[2px]"
    [innerHTML]="
      processContent(
        (contentInfo.copyright || '') +
          '<span class=\'inline-block tablet:px-12 mobile:px-[6px] text-center\'>|</span>' +
          (contentInfo.disclaimer1 || '')
      )
    "
  ></p>
  <p
    id="mach-homepage-footer-infomation-p3"
    class="tablet:text-body-xs mobile:text-caption-book text-center text-navigation flex-none order-0 mb-[2px]"
    [innerHTML]="processContent(contentInfo.disclaimer2 || '')"
  ></p>
</div>
